/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import  * as Msdyn365 from '@msdyn365-commerce/core';
import { ICittaInvDlvBannerData } from './citta-inv-dlv-banner.data';
import { ICittaInvDlvBannerProps } from './citta-inv-dlv-banner.props.autogenerated';
import { hSOCustomerEntityAsync } from '../../actions/DataActionExtension.g';
import { CloseButton} from './components/close-button';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

export interface ICittaInvDlvBannerViewProps extends ICittaInvDlvBannerProps<ICittaInvDlvBannerData> {
    noStatus?: React.ReactNode;
    taxStatus?: React.ReactNode;
    allStatus?: React.ReactNode;
    status?: number;
    closeButton?: React.ReactNode;
}

/**
 *
 * CittaInvDlvBanner component
 * @extends {React.PureComponent<ICittaInvDlvBannerProps<ICittaInvDlvBannerData>>}
 */
interface Icustomerobject {
    customerstate: number;
    visible: boolean;
}

class CittaInvDlvBanner extends React.PureComponent<ICittaInvDlvBannerProps<ICittaInvDlvBannerData>> {
    public custstatus: number = 99;
    public state: Icustomerobject;

    public async componentDidMount(): Promise<void> {
        let custid = this.props.data.customerInformation && this.props.data.customerInformation.result?.AccountNumber;
        if(custid!=undefined)
        {
            let custobj : Entities.Customer = await hSOCustomerEntityAsync({ callerContext: this.props.context.actionContext }, custid!);
            this.custstatus = 0;
            const customerExtensionProperties = custobj.ExtensionProperties;
            customerExtensionProperties?.forEach(element => {
                if (element.Key == 'HSOCustBlockedStatus'){
                    this.custstatus = element.Value?.IntegerValue!;
                }
            })
            this.setState({ customerstate: this.custstatus })
        }
        console.log(custid);
    }

    public constructor(props: ICittaInvDlvBannerProps<ICittaInvDlvBannerData>) {
        super(props);
        this.state = {
            customerstate: 99,
            visible:true
        };

    }

    public render(): JSX.Element | null {
        const { closeButtonAriaLabel, closeButtonLabel } = this.props.resources;
        const { nostatus, taxstatus, alltatus, dismissEnabled } = this.props.config;
        if(!this.state.visible || this.state.customerstate == 0){
            return null;
        }

        const AllStatus = alltatus && (
            <Msdyn365.RichTextComponent
                text={alltatus}
                className='ms-content-block__text'
            />
        );  
        const TaxStatus = alltatus && (
            <Msdyn365.RichTextComponent
                text={taxstatus}
                className='ms-content-block__text'
            />
        ); 
        const NoStatus = alltatus && (
            <Msdyn365.RichTextComponent
                text={nostatus}
                className='ms-content-block__text'
            />
        );

        //let NoStatus = config.nostatus ? config.nostatus : 'No';
        //let TaxStatus = config.taxstatus ? config.taxstatus : 'Tax';
        //let AllStatus = config.alltatus ? config.alltatus : 'All';
        
        const CittaInvDlvBannerProps = {
            ...this.props,
            noStatus: NoStatus,
            taxStatus: TaxStatus,
            allStatus: AllStatus,
            status: this.state.customerstate,
            closeButton: dismissEnabled && <CloseButton {...{ onClose: this._onDismiss, label: closeButtonLabel, closeButtonAriaLabel }} />
        };
        return this.props.renderView(CittaInvDlvBannerProps) as React.ReactElement;
    }

    private _onDismiss = (): void => {
        this.setState({ visible: false });
    };
}

export default CittaInvDlvBanner;
